import React, { memo } from 'react'
import { IBackGroundSize, useStyles } from './Image.styles'

export enum BackgroundPositionEnum {
  TOP = 'top',
  CENTER = 'center',
  BOTTOM = 'bottom'
}

interface IImageProps {
  backgroundUrl: string
  backgroundSize?: IBackGroundSize
  backgroundPosition?: BackgroundPositionEnum
  ratio?: number
  height?: string
  highlightable?: boolean
  className?: string
}

export const Image = memo(
  ({
    backgroundUrl,
    backgroundSize = 'preserve-ratio',
    backgroundPosition = BackgroundPositionEnum.CENTER,
    height,
    ratio,
    highlightable = true,
    className
  }: IImageProps) => {
    const classes = useStyles({
      backgroundUrl,
      backgroundSize,
      backgroundPosition,
      ratio,
      height
    })
    const highlightableClassName = highlightable ? 'highlightable' : null

    return <div className={`${classes.root} ${highlightableClassName} ${className}`}></div>
  }
)
